/* eslint-disable @typescript-eslint/restrict-plus-operands */
import RentalsPopover, { Rental } from './components/RentalsPopover'
import { StorePart } from '../../../graphql'

function render( storePart: StorePart ) {
	const rentals: Rental[] = storePart.rentalItems
	return (
		<RentalsPopover rentals={rentals} />
	)
}

export default {
	name: 'On Rent',
	render,
}
